import { render } from "./CertificateGeneratorDownloads.vue?vue&type=template&id=3fb56cd6"
import script from "./CertificateGeneratorDownloads.vue?vue&type=script&lang=js"
export * from "./CertificateGeneratorDownloads.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__